module.exports = __webpack_public_path__ + "img/banner2_9_jp.62391305.png";